import React from 'react';
import { Mic, Brain, Layers } from 'lucide-react';
import PhasePageTemplate from './PhasePageTemplate';

const PhaseStrategyCall = () => (
  <PhasePageTemplate
    phaseNumber="02"
    phaseName="The Strategy Call"
    tagline="A one-hour recorded conversation that becomes the brain of your agent. What you say on this call is what your agent knows."
    heroImage="/images/generated/process-hero-strategy.png"
    conceptImage="/images/generated/process-concept-strategy.png"
    delivers={[
      {
        icon: <Mic className="w-6 h-6" />,
        title: 'Your Agent\'s Knowledge Base',
        desc: 'The transcript from this call is the primary source material for your agent\'s identity, priorities, and business context. No call, no depth.',
      },
      {
        icon: <Brain className="w-6 h-6" />,
        title: 'Your Agent\'s Personality',
        desc: 'We capture how you communicate, what your tone is, what matters to you — so your agent sounds like it belongs in your business, not ours.',
      },
      {
        icon: <Layers className="w-6 h-6" />,
        title: 'Your Integration Priorities',
        desc: 'We confirm exactly which tools get connected first, which workflows are highest priority, and what\'s out of scope for now.',
      },
    ]}
    whyTitle="The transcript is your agent's brain."
    whyBody="There's no shortcut to a well-trained agent. We can write prompts and connect APIs, but the intelligence has to come from somewhere — and that somewhere is you. This call is recorded precisely so we can train your agent on your actual language, your real priorities, and your genuine style. A shallow call produces a shallow agent. We ask hard, specific questions to make sure we don't deliver that."
    experienceTitle="An hour of real conversation — not a demo, not a sales pitch."
    experienceBody="This is a 1-hour working session with your build team. We ask about how your business runs today, where the friction is, what your team handles versus what falls through the cracks. We want to understand what success looks like for you in 90 days — specifically. Not 'save time,' but 'stop manually entering every job from my CRM into my calendar.' The more specific, the better your agent."
    experienceHighlights={[
      'Questions like: What does your follow-up process look like today? Who handles scheduling, and what breaks?',
      'Questions like: Which tools do you check every morning, and which ones you wish you didn\'t have to?',
      'Questions like: If your agent could do one thing flawlessly for you starting tomorrow, what would it be?',
      'We record and transcribe the call — you don\'t need to take notes',
    ]}
    timeline="1 hour"
    todoItems={[
      'Show up to the scheduled call',
      'Be specific — vague answers produce vague agents',
      'Have your tool list handy if possible (we\'ll ask about them)',
    ]}
    prevPhase={{ name: 'The Discovery Form', href: '/process/discover' }}
    nextPhase={{ name: 'Building Your Agent', href: '/process/build' }}
  />
);

export default PhaseStrategyCall;
